

















import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-child',
  components: {}
}

@Component(config)
export default class IconChild extends Vue {}
